import { check } from "./check";
import type { RuntimeManifest } from "./manifest";

export async function fetchManifest(manifestPath: string) {
  const r = await fetch(manifestPath, { cache: "no-store" });
  return r.json();
}

export async function scanAllScripts(
  manifest: RuntimeManifest,
  verbose: boolean,
  relaxedHosts: string[] = [],
) {
  return Promise.all(
    Array.from(document.scripts).map((n) =>
      check(n as HTMLScriptElement, manifest, verbose, relaxedHosts),
    ),
  );
}

export function observeNewScripts(
  manifest: RuntimeManifest,
  verbose: boolean,
  relaxedHosts: string[] = [],
) {
  const obs = new MutationObserver((m) =>
    m
      .flatMap((x) => Array.from(x.addedNodes))
      .filter((n) => n.nodeName === "SCRIPT")
      .forEach((n) => {
        void check(n as HTMLScriptElement, manifest, verbose, relaxedHosts);
      }),
  );
  obs.observe(document.documentElement, { childList: true, subtree: true });
  return obs;
}
